import { Component, OnInit, computed, signal } from '@angular/core';
import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { IAuthMenu } from '../../models';
import { RequestAccess, RequestMenu } from '../../models/messages';
import { AuthorizationService } from '../../services';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-admin-card',
  templateUrl: './admin-card.component.html',
  styleUrls: ['./admin-card.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgTemplateOutlet, NgbDropdownItem]
})


export class AdminCardComponent implements OnInit {

  menuItems = signal<IAuthMenu[]>([]);
  hasItems = computed(() => this.menuTreeHasItems(this.menuItems()));

  constructor(protected authService: AuthorizationService) {
    // Listen for Okta authentication state changes
    // @ts-ignore: access to private property for demonstration; ideally expose OktaAuth via AuthorizationService
    const oktaAuth = (this.authService as any).oauth;
    if (oktaAuth && oktaAuth.authStateManager) {
      oktaAuth.authStateManager.subscribe((authState: any) => {
        if (authState.isAuthenticated) {
          this.refreshMenu();
        }
      });
    }
  }

  ngOnInit() {
    this.refreshMenu();
  }

  refreshMenu(): void {
    let req: RequestMenu = new RequestMenu();
    req.hierarchyCode = "admin";

    this.authService.isReadyToUse().then(isAuth => {
      if (!isAuth) {
        return;
      }

      const licReq = new RequestAccess();
      licReq.route = '/home';

      this.authService.hasAccess$(licReq)
        .pipe(
          map(result => result.isLicensed === true),
          catchError(() => of(false))
        )
        .subscribe(isLicensed => {
          if (!isLicensed) {
            this.menuItems.set([]);
            return;
          }

          this.authService.menuGet$(req).subscribe((data: IAuthMenu[]) => {
            this.menuItems.set(data);
          });
        });
    });
  }

  isItemRouteInternal(url: string): boolean {

    if (url.startsWith("http"))
      return false;
    else
      return true;
  }

  private menuTreeHasItems(items: IAuthMenu[] | undefined): boolean {
    if (!items || items.length === 0)
      return false;

    return items.some(item =>
      item.hasChildren
        ? this.menuTreeHasItems(item.children)
        : !!(item.url && item.url.length > 0)
    );
  }
}
